import React from 'react';
import { styled, Box, Typography, TextField, Button, Menu, MenuItem, Checkbox } from '@mui/material';
import RecentPaginatedTable from '../firstPage/RecentPaginatedTable';
import { useDispatch, useSelector } from 'react-redux';
import { transaction } from '../../components/utils/selectors/selectors';
import { userLSAuth } from '../../components/app/features/env';
import noTransIcon from '../../assets/noTrans.svg';
import { getPaginatedActivities } from '../../components/app/features/transactions/TransactionSlice';
import backImg from '../../assets/back.svg';
import { FaSearch, FaFilter } from 'react-icons/fa';

export const Wrapper = styled(Box)(
   ({ theme }) => `
background: #EFEEF4;  
min-height: 100vh;  
padding-top:${theme.header.height}; 
padding-bottom: 2rem;
`
);
export const Container = styled(Box)(
   ({ theme }) => `
 width: 95%;
max-width: 950px;
min-height: 100vh;
margin: 2rem auto 0 auto;


 `
);

export const FilterButton = styled(Button)(
   ({ theme }) => `
   background: #FFFFFF;
   color: #2E2C21;
   border-radius: 12px;
   padding: 12px 16px;
   font-weight: 500;
   font-size: 14px;
   text-transform: none;
   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
   border: none;
   min-width: 120px;
   display: flex;
   align-items: center;
   gap: 8px;
   &:hover {
      background: #F8F8F8;
   }
`
);

export const SearchInput = styled(TextField)(
   ({ theme }) => `
   background: #FFFFFF;
   border-radius: 12px;
   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
   & .MuiOutlinedInput-root {
      border-radius: 12px;
      padding-right: 12px;
   }
   & .MuiOutlinedInput-notchedOutline {
      border: none;
   }
   & .MuiInputBase-input {
      padding: 12px 16px;
      font-size: 14px;
   }
`
);

export const FilterMenu = styled(Menu)(
   ({ theme }) => `
   & .MuiPaper-root {
      background: #FFFFFF;
      border-radius: 12px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      margin-top: 8px;
      min-width: 200px;
   }
`
);

export const FilterMenuItem = styled(MenuItem)(
   ({ theme }) => `
   padding: 12px 16px;
   font-size: 14px;
   color: #2E2C21;
   display: flex;
   align-items: center;
   justify-content: space-between;
   &:hover {
      background: #F8F8F8;
   }
   &.Mui-selected {
      background: #E3F2FD;
      color: #1976D2;
   }
`
);

export const ControlsContainer = styled(Box)(
   ({ theme }) => `
   display: flex;
   gap: 16px;
   margin-bottom: 24px;
   align-items: center;
   justify-content: flex-end;
   flex-wrap: wrap;
   @media (max-width: 600px) {
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
   }
`
);

const Activity = () => {
   const selector = useSelector(transaction);
   const dispatch = useDispatch();
   const [page, setPage] = React.useState(1);
   const [data, setData] = React.useState([]);
   const [searchTerm, setSearchTerm] = React.useState('');
   const [filterAnchorEl, setFilterAnchorEl] = React.useState(null);
   const [selectedFilter, setSelectedFilter] = React.useState('All');
   const [filteredData, setFilteredData] = React.useState([]);

   const filterOptions = [
      { value: 'All', label: 'All Activities' },
      { value: 'Account top-up', label: 'Account top-up' },
      { value: 'Sent SMS', label: 'Sent SMS' },
      { value: 'Unit transfer', label: 'SMS units transfer' },
      { value: 'Scheduled SMS', label: 'Scheduled SMS' },
      { value: 'Added Contacts', label: 'Added Contacts' },
      { value: 'Sender ID', label: 'Sender ID' }
   ];

   React.useEffect(() => {
      dispatch(getPaginatedActivities({ page: page }));
   }, [page]);

   React.useEffect(() => {
      if (selector.paginatedActivities) {
         setData(selector.paginatedActivities);
         setFilteredData(selector.paginatedActivities);
         const uniqueActions = [...new Set(selector.paginatedActivities.map(activity => activity.action))];
         console.log('Available actions:', uniqueActions);
      }
   }, [selector.paginatedActivities]);

   // Filter and search logic
   React.useEffect(() => {
      let filtered = [...data];
      if (selectedFilter !== 'All') {
         console.log('Filtering by:', selectedFilter);
         filtered = filtered.filter(activity => {
            const matches = activity.action === selectedFilter;
            console.log(`Activity action: "${activity.action}" matches "${selectedFilter}":`, matches);
            return matches;
         });
      }


      if (searchTerm.trim()) {
         console.log('Searching for:', searchTerm);
         filtered = filtered.filter(activity => {
            const matches = activity.action && activity.action.toLowerCase().includes(searchTerm.toLowerCase());
            console.log(`Activity action: "${activity.action}" contains "${searchTerm}":`, matches);
            return matches;
         });
      }

      console.log('Filtered data length:', filtered.length);
      setFilteredData(filtered);
   }, [data, selectedFilter, searchTerm]);

   const updatePage = (page) => setPage(page);

   const handleFilterClick = (event) => {
      setFilterAnchorEl(event.currentTarget);
   };

   const handleFilterClose = () => {
      setFilterAnchorEl(null);
   };

   const handleFilterSelect = (filterValue) => {
      setSelectedFilter(filterValue);
      handleFilterClose();
   };

   const handleSearchChange = (event) => {
      setSearchTerm(event.target.value);
   };

   return (
      <Wrapper>
        
         
         <Container>
         <Box className="topUpWrapper" sx={{ paddingBottom: '2rem' }}>
               <img
                  src={backImg}
                  alt="back"
                  style={{
                     width: '40px',
                     cursor: 'pointer',
                  }}
                  onClick={() => window.history.back()}
               />
            </Box>
            <Typography
               sx={{
                  // border: '1px solid red',
                  color: '#2E2C21',
                  width: '90%',
                  maxWidth: '615px',
                  margin: '0 auto',
                  borderRadius: '15px',
                  minHeight: '105px',
                 
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 'clamp(1.8rem, 2.5vw, 2.5rem)',
                  fontWeight: '600',
                  wordSpacing: '0.5rem',
                  mb: 5,
               }}
               className='font-cormorant'
            >
               {' '}
               Activity History
            </Typography>

            {/* Filter and Search Controls */}
            <ControlsContainer>
               <FilterButton
                  onClick={handleFilterClick}
                  endIcon={<FaFilter size={14} />}
               >
                  Filter by
               </FilterButton>
               
               <SearchInput
                  placeholder="Search activity"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  InputProps={{
                     startAdornment: <FaSearch style={{ marginRight: '8px', color: '#666' }} size={16} />
                  }}
                  sx={{ minWidth: '200px', maxWidth: '300px' }}
               />
            </ControlsContainer>

            {/* Filter Dropdown Menu */}
            <FilterMenu
               anchorEl={filterAnchorEl}
               open={Boolean(filterAnchorEl)}
               onClose={handleFilterClose}
               anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
               }}
               transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
               }}
            >
               {filterOptions.map((option) => (
                  <FilterMenuItem
                     key={option.value}
                     onClick={() => handleFilterSelect(option.value)}
                     selected={selectedFilter === option.value}
                  >
                     {option.label}
                     {selectedFilter === option.value && (
                        <Checkbox
                           checked={true}
                           size="small"
                           sx={{ padding: 0, marginLeft: 1 }}
                        />
                     )}
                  </FilterMenuItem>
               ))}
            </FilterMenu>

            <Box>
               {filteredData.length > 0 ? (
                  <RecentPaginatedTable updatePage={updatePage} data={filteredData} />
               ) : (
                  <Box sx={{ marginTop: '20vh' }}>
                     <Box sx={{ textAlign: 'center', marginTop: '2rem' }}>
                        <img
                           src={noTransIcon}
                           style={{
                              width: '180px',
                           }}
                           alt="icon"
                        />
                     </Box>
                     <Typography
                        sx={{
                           fontWeight: 500,
                           fontSize: 'clamp(1rem, 1.5vw, 1.1rem)',
                           color: '#0F0E0E',
                           marginTop: '1rem',
                           marginBottom: '1rem',
                           textAlign: 'center',
                        }}
                     >
                        {selector.paginatedActivities.length === 0 
                           ? `Hey ${userLSAuth()?.fullName.split(' ')[0]}, your Activity History will appear here`
                           : 'No activities found matching your search criteria'
                        }
                     </Typography>
                  </Box>
               )}
            </Box>
         </Container>
      </Wrapper>
   );
};

export default Activity;
